import React from 'react'
import PropTypes from 'prop-types'
import { RootMeta } from 'components/Meta'
import WorkoutSlide from 'components/Frontpage/WorkoutSlide'
// import StoriesSlide from 'components/Frontpage/StoriesSlide'
import ArticlesSlide from 'components/Frontpage/ArticlesSlide'

const IndexPage = ({ data }) => {
  const {
    site: { siteMetadata },
    // instagramPosts,
    articles: { edges: articles },
    tags: { edges: tags },
    // stories: { edges: stories },
    featuredStories,
    workoutsMentions: { edges: workoutsMentions },
  } = data

  // const sortedInstagramPosts = orderBy(
  //   instagramPosts.edges,
  //   ({ node }) => node.date,
  //   ['desc'],
  // )

  return (
    <div>
      <RootMeta
        url={siteMetadata.siteUrl}
        title={`Home | ${siteMetadata.siteName}`}
        description={siteMetadata.siteDescription}
      />
      <ArticlesSlide
        // instagramPosts={sortedInstagramPosts}
        articles={articles}
        tags={tags}
        featuredStories={featuredStories}
      />
      {/* <StoriesSlide stories={stories} /> */}
      <WorkoutSlide workoutsMentions={workoutsMentions} />
    </div>
  )
}

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
}

// prettier-ignore
// eslint-disable-next-line
export const QueryHome = graphql`
  query QueryHome {
    site {
      siteMetadata {
        siteName
        siteUrl
        siteDescription
      }
    }
    articles: allMarkdownRemark(
      limit: 4,
      filter: { id: { regex: "/(\/pages\/articles|\/pages\/reviews)/" } },
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          excerpt(pruneLength: 300)
          timeToRead
          fields {
            slug
          }
          frontmatter {
            title
            uiTitle
            date
            thumbnail
            shortDescription
            tags
            references
            category
            pageType
          }
        }
      }
    }
    ####### PREPARING FOR RE-WRITE FOR BETTER ARTICLE SORTING
    # allFile(
    #   limit: 4,
    #   filter: { relativePath:{regex:"/^(articles\/|reviews\/)/"} },
    #   sort: { order: DESC, fields: [birthtimeMs]}
    # ) {
    #   edges {
    #     node {
    #       birthtimeMs
    #       childMarkdownRemark {
    #         excerpt(pruneLength: 300)
    #         timeToRead
    #         fields {
    #           slug
    #         }
    #         frontmatter {
    #           title
    #           uiTitle
    #           date
    #           thumbnail
    #           shortDescription
    #           tags
    #           references
    #           category
    #           pageType
    #         }
    #       }
    #     }
    #   }
    # }
    tags: allMarkdownRemark(
      filter: { id: { regex: "/\/pages\/articles/"} },
    ) {
      edges {
        node {
          frontmatter {
            tags
          }
        }
      }
    }
    # stories: allMarkdownRemark(
    #   limit: 10,
    #   filter: { id: { regex: "/\/pages\/(stories)/" } },
    #   sort: { order: DESC, fields: [frontmatter___date] }
    # ) {
    #   edges {
    #     node {
    #       excerpt(pruneLength: 300)
    #       timeToRead
    #       fields {
    #         slug
    #       }
    #       frontmatter {
    #         title
    #         date
    #         author
    #         sponsored
    #         featured
    #         thumbnail
    #         source
    #         shortDescription
    #         tags
    #         references
    #       }
    #     }
    #   }
    # }
    featuredStories: allMarkdownRemark(
      limit: 3,
      filter: { id: { regex: "/\/pages\/(stories)/" }, frontmatter: { featured: { eq: true }} },
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          excerpt(pruneLength: 160)
          timeToRead
          fields {
            slug
          }
          frontmatter {
            title
            date
            sponsored
            featured
            thumbnail
            storyFrom
          }
        }
      }
    }
    workoutsMentions: allMarkdownRemark(filter: {
      frontmatter: {
        pageType: { eq:"workout" }
        title: { regex: "/(Squats|Running|Power Yoga)/" }
      }
    }) {
      edges {
        node {
          frontmatter {
            title
            mentions
          }
        }
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js